import React, { useRef, useState, useEffect, Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import classes from './styles.module.css';

function UserSearchList({ users = [], onUsersChange, usersList = [], isLoading = true, onEditPermissions = null }) {
    const intl = useIntl();
    const [searchTerm, setSearchTerm] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const containerRef = useRef(null);
    const inputRef = useRef(null);

    const safeLowerCase = (str) => (typeof str === 'string' ? str : '').toLowerCase();

    const filteredUsers = usersList.filter((user) => {
        const username = (user && user.username) || '';
        const email = (user && user.email) || '';
        const id = String((user && user.id) || '');
        const lowerSearch = safeLowerCase(searchTerm);

        return (
            safeLowerCase(username).includes(lowerSearch) ||
            safeLowerCase(email).includes(lowerSearch) ||
            safeLowerCase(id).includes(lowerSearch)
        );
    });

    function addUser(id) {
        const user = usersList.find((u) => u && String(u.id) === id);
        if (user && !users.find((u) => u && u.username === user.username)) {
            onUsersChange([...users, user]);
            setSearchTerm('');
            setIsDropdownOpen(false);
            if (inputRef.current) inputRef.current.focus();
        }
    }

    function removeUser(id) {
        onUsersChange(users.filter((u) => u && String(u.id) !== id));
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    if (isLoading) {
        return (
            <div className={classes.Wrapper} ref={containerRef}>
                <div className={classes.LoadingWrapper}>
                    <div className={classes.Spinner} />
                    <span>
                        <FormattedMessage id="UserSearchList.loading" defaultMessage="Загрузка пользователей..." />
                    </span>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.Wrapper} ref={containerRef}>
            <div className={classes.SearchContainer}>
                <input
                    ref={inputRef}
                    type="text"
                    className={classes.SearchInput}
                    placeholder={intl.formatMessage({ id: 'UserSearchList.placeholder' })}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onFocus={() => setIsDropdownOpen(true)}
                />
                {isDropdownOpen && filteredUsers.length > 0 && (
                    <ul className={classes.DropdownList}>
                        {filteredUsers
                            .filter((u) => u && !users.find((selected) => selected && selected.username === u.username))
                            .map((user) => {
                                const displayName = (user && user.username) || '';
                                return (
                                    <li
                                        key={user && user.id}
                                        className={classes.DropdownItem}
                                        onClick={() => addUser(String(user && user.id))}
                                    >
                                        <div className={classes.DropdownItemTitle}>{displayName}</div>
                                        <div className={classes.DropdownItemUuid}>
                                            {(user && user.id) || ''} • {(user && user.email) || '—'}
                                        </div>
                                    </li>
                                );
                            })}
                    </ul>
                )}
                {isDropdownOpen && filteredUsers.length === 0 && searchTerm && (
                    <div className={classes.DropdownEmpty}>
                        <FormattedMessage id="UserSearchList.empty" defaultMessage="Ничего не найдено" />
                    </div>
                )}
            </div>

            {users.length > 0 && (
                <Fragment>
                    <h5 className={classes.SelectedTitle}>
                        <FormattedMessage id="UserSearchList.selected.title" defaultMessage="Выбранные пользователи" />
                    </h5>
                    <ul className={classes.SelectedList}>
                        {users.map((u) => {
                            const displayName = (u && u.username) || '';
                            return (
                                <li key={u && u.id} className={classes.SelectedItem}>
                                    <span>
                                        {displayName} ({(u && u.email) || '—'})
                                    </span>
                                    <div className={classes.ItemActions}>
                                        {onEditPermissions && (
                                            <button
                                                className={classes.PermissionsBtn}
                                                onClick={() => onEditPermissions(u)}
                                                title={intl.formatMessage({
                                                    id: 'UserSearchList.permissions.title',
                                                    defaultMessage: 'Настроить права',
                                                })}
                                            >
                                                <FormattedMessage
                                                    id="UserSearchList.permissions.btn"
                                                    defaultMessage="Права"
                                                />
                                            </button>
                                        )}
                                        <button
                                            className={classes.RemoveBtn}
                                            onClick={() => removeUser(String(u && u.id))}
                                            aria-label={intl.formatMessage(
                                                { id: 'UserSearchList.remove.aria' },
                                                { name: displayName }
                                            )}
                                        >
                                            X
                                        </button>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </Fragment>
            )}
        </div>
    );
}

export default UserSearchList;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/UserSearchList/index.js